import {
  DefaultButton,
  INavLink,
  INavLinkGroup,
  IconButton,
  Nav,
  Pivot,
  PivotItem,
  PrimaryButton,
} from "@fluentui/react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { AppRoutes } from "../../Constants/AppRoutes";
import { IUser } from "../../Models/IUser";
import { GlobalState } from "../../Redux/RootReducer";
import IconButtonItem from "../IconButtonItem/IconButtonItem";
import "./NavigationMenu.scss";
import { IRole } from "../../Models/IRole";

export interface INavigationMenuProps {}

interface INavPage {
  name: string;
  icon: string;
  url: string;
}

const getNavLinks = (user: IUser | undefined) => {
  const pages: INavPage[] = [
    // deprecated
    /*{
      name: "Sorveglianza",
      url: AppRoutes.APP_MONITORING_PAGE,
      icon: "TVMonitor",
    },*/

    {
      name: "Home",
      url: AppRoutes.APP_LANDING_PAGE,
      icon: "HomeGroup",
    },
    {
      name: "Configurazione",
      url: AppRoutes.APP_CONFIGURE_PAGE,
      icon: "TaskManager",
    },
    {
      name: "Schede",
      url: AppRoutes.APP_CLINICAL_RECORD_PAGE,
      icon: "FolderOpen",
    },
  ];

  if (
    user &&
    (user.roles.filter((x: IRole) => x.type === "superOperator").length > 0 ||
      user.roles.filter((x: IRole) => x.type === "superAdmin").length > 0 ||
      user.roles.filter((x: IRole) => x.type === "installer").length > 0)
  ) {
    pages.push({
      name: "Allarmi",
      url: AppRoutes.APP_ALARMS_PAGE,
      icon: "ClipboardList",
    });
    pages.push({
      name: "Statistiche",
      url: AppRoutes.APP_STATISTIC_PAGE,
      icon: "LineChart",
    });
  }

  if (
    user &&
    (user.roles.filter((x: IRole) => x.type === "superAdmin").length > 0 ||
      user.roles.filter((x: IRole) => x.type === "installer").length > 0)
  ) {
    pages.push({
      name: "Setup",
      url: AppRoutes.APP_SETUP_PAGE,
      icon: "Admin",
    });
  }

  return pages;
};

const NavigationMenu = (props: INavigationMenuProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const loggedUser = useSelector((s: GlobalState) => s.generic.user);
  const [selectedKey, setSelectedKey] = useState<string>(location.pathname);
  const navLinks: INavPage[] = getNavLinks(loggedUser);

  useEffect(() => {
    setSelectedKey(location.pathname);
  }, [location]);

  const current = navLinks.find((x: INavPage) => x.url === selectedKey);
  return (
    <div className="button-holder">
      {/* telefono: le pagine stanno in un menu, la corrente è segnata (le sei icone non ci stavano) */}
      <DefaultButton
        className="menu-button-nav"
        iconProps={{ iconName: "GlobalNavButton" }}
        text={current ? current.name : "Menu"}
        menuProps={{
          items: navLinks.map((x: INavPage) => ({
            key: x.url,
            text: x.name,
            iconProps: { iconName: x.icon },
            canCheck: true,
            checked: selectedKey === x.url,
            onClick: () => {
              navigate(x.url);
            },
          })),
        }}
      />
      {navLinks.map((x: INavPage, i: number) => {
        return (
          <div key={i}>
            <IconButton
              className="icon-button-nav"
              iconProps={{ iconName: x.icon }}
              toggle
              checked={selectedKey === x.url}
              text={x.name}
              onClick={() => {
                navigate(x.url);
              }}
            />

            <DefaultButton
              className="normal-button-nav"
              iconProps={{ iconName: x.icon }}
              toggle
              checked={selectedKey === x.url}
              text={x.name}
              onClick={() => {
                navigate(x.url);
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default NavigationMenu;
